const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/

const PASSWORD_REGEX = /^.*(?=^.{8,14}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[`.~!@#$%^&*()_+=-]).*$/

const UNIT_SQUAD_REGEX = /(\^)(\d+)/

const METRIC_UNIT_REGEX = /({|})/g

const INPUT_TIME_REGEX = /\s([0-1][0-9]|2[0-3]):([0-5]?[0-9]):([0-5][0-9])$/

const YEAR_TO_DAY_FORMAT = "yyyy-MM-dd"
const HOUR_TO_SECOND_FORMAT = "HH:mm:ss"
const FULL_DATE_FORMAT = "yyyy-MM-dd HH:mm:ss"

export {
  EMAIL_REGEX as emailRegex,
  PASSWORD_REGEX as passwordRegex,
  UNIT_SQUAD_REGEX as unitSquadRegex,
  METRIC_UNIT_REGEX as metricUnitRegex,
  INPUT_TIME_REGEX,
  YEAR_TO_DAY_FORMAT,
  HOUR_TO_SECOND_FORMAT,
  FULL_DATE_FORMAT,
}
